<template>
    <sections>
        <section-jumbo
            :image="$config.public.images + 'west-coast-swing-leeds-headingley.jpg'"
            imagePosition="object-center"
            imageOpacity="opacity-80"
        ></section-jumbo>
        <section-cookies></section-cookies>
        <section-text
            heading="West Coast Swing"
            headingComponent="h2"
            content="<article-home />"
            :textCentered="true"
        ></section-text>
        <section-image
            v-if="events !== null"
            v-for="(event, index) in events"
            :key="event.id_event"
            :color="Math.abs(index % 2) === 1 ? 'white' : 'bg-zinc-50'"
            :image="$config.public.images + event.event_image"
            image-aspect-ratio="aspect-[40/21]"
            :heading="event.event_title"
            :content="event.event_excerpt"
            buttonText="More Details"
            :buttonRoute="`/events/${event.event_slug}`"
        ></section-image>
        <loading-section :loading="true" v-else></loading-section>
        <section-text
            color="bg-zinc-100"
            heading="Fresh Modern Improvised"
            content="<p>West Coast Swing classes in Headingley, Leeds UK</p>"
            :textCentered="true"
        ></section-text>
    </sections>
</template>

<script setup>
const {events} = storeToRefs(useStoreEvents());
const {getEvents} = useStoreEvents();

await useLazyAsyncData('getEvents', () => getEvents().then(() => true));

const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'West Coast Swing Leeds | ' + $config.public.siteName,
    description:
        'West Coast Swing classes in Headingley, suitable for absolute beginners - no partner or special clothes required.',
    image: $config.public.images + 'west-coast-swing-leeds-headingley.jpg',
    index: true,
});
</script>
